import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Michelle Starbuck Designs (b_fe0544c3, advertiser -7306702707667101881).
// Lifetime complete-month metrics through Aug 2026.
export const advMichelleStarbuck: FaireAdvertiserProfileEntity = {
  token: "adv_michelle_starbuck",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "Michelle Starbuck Designs",
  brandToken: "b_fe0544c3",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 26,
  budget: {
    totalBudgetDollars: 500,
    sharedBudgetDollars: 500,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 16,
    numReorderConversions: 9,
    numTotalConversions: 25,
    totalAdsSalesDollars: 22997,
    newCustomerAdsSalesDollars: 19585,
    reorderAdsSalesDollars: 3412,
    totalAdsSpendDollars: 3991,
    newCustomerAdsSpendDollars: 3432,
    reorderAdsSpendDollars: 559,
    newCustomerBestEstimateFirstYearRoas: 4.46,
    reorderRoas: 6.1,
    combinedFirstYearRoas: 4.69,
    numNewCustomerAdsOrders: 58,
    numReorderAdsOrders: 11,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 1210,
      maxRecommendedBudgetDollars: 2420,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 150,
      maxRecommendedBudgetDollars: 300,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_msd_new", "camp_msd_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
